// Hook do tworzenia nowego procesu

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import { IProcessDetails, IProcessSchema, IApiProcessDetails, IApiProcessSchema, transformSchema } from './useGetProcess';

export interface IPostProcessRequest {
  name: string;
  description?: string;
  type: string;
  module_id: number;
  status?: string;
  additional_data?: {
    event_class?: string;
    policy_kind_tag?: string;
    policy_subtype_class?: string;
    additional_fields_service_interface?: string;
    product_label_field?: string;
    translations?: Record<string, string>;
    provider_kind_tag?: string;
    entity_class?: string;
  };
  workflows?: any[]; // Array of workflows (methods with workflow data)
}

const postProcess = async (data: IPostProcessRequest): Promise<IProcessDetails> => {
  const response: ICommandResponseSuccess = await axios.post('/dev-studio/process', data) as unknown as ICommandResponseSuccess;
  
  // Odpowiedź ma strukturę { status: 1, data: { id: 5, ... } }
  const apiResponse = response.data as unknown as IApiProcessDetails;
  
  return {
    id: apiResponse.id,
    name: apiResponse.name,
    description: apiResponse.description,
    type: apiResponse.type,
    status: apiResponse.status,
    moduleId: apiResponse.module_id,
    schema: apiResponse.schema ? transformSchema(apiResponse.schema) : null,
    lastExecution: apiResponse.last_execution ?? null,
    executionCount: apiResponse.execution_count ?? 0,
    successRate: apiResponse.success_rate ?? null
  };
};

export const usePostProcess = (
  options?: UseMutationOptions<IProcessDetails, IError, IPostProcessRequest>
) => useMutation<IProcessDetails, IError, IPostProcessRequest>(postProcess, options);
